import * as Sentry from '@sentry/react';

export const initSentry = () => {
  Sentry.init({
    dsn: 'https://c8a32b98ae483df66544f390558ec493@o397604.ingest.us.sentry.io/4509413801263104',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    environment: process.env.NODE_ENV || 'development',
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    enabled: process.env.NODE_ENV === 'production',
  });
};

type SentryUser = {
  [key: string]: any; // Allow any additional properties
  name?: string;
  uid?: string;
  sessionID?: string;
  email?: string;
};

export const setSentryUser = (user: SentryUser) => {
  Sentry.setUser({ ...user, frontend: true });
};

/**
 * Capture an error and send it to Sentry. Ignores 401 unauthorized errors, since they are expected
 * and we handle them in an axios interceptor.
 */
export const captureException = (error: unknown, data?: object) => {
  console.error(error, data);
  data = { ...data, frontend: true };
  Sentry.captureException(error, { ...data });
};
